import angular from "angular";
import chatModule from '../chatModule';

function dialogsController($scope, chatService, chatUtility, messageService, $log) {
    "ngInject";

    $scope.isNewGroupChat = function (conversation) {
        return conversation.dialogType === chatUtility.dialogType.NEWGROUPCHAT
                    || (conversation.addMoreFriends
                        && !conversation.isGroupChat);
    }

    $scope.canAddFriendInExistedConversation = function (conversation) {
        return conversation.addMoreFriends
                && conversation.isGroupChat;
    }

    $scope.resetPreviousDialog = function (oldLayoutId, newLayoutId, preDialogData) {
        $scope.chatUserDict[oldLayoutId]['selectedUserIds'] = [];
        $scope.chatUserDict[oldLayoutId]['selectedUsersDict'] = {};
        if (!preDialogData.preserved) {
            delete $scope.chatUserDict[oldLayoutId];
        } else {
            $scope.chatUserDict[oldLayoutId].addMoreFriends = false;
        }

        // update dialogList for position and dialog status
        var position = $scope.chatLibrary.dialogIdList.indexOf(oldLayoutId);
        if (position > -1 && !preDialogData.preserved) { // legacy dialog existed but no need to keep, such as new group creation
            $scope.destroyDialogLayout(oldLayoutId);
            delete $scope.chatLibrary.dialogDict[oldLayoutId];
            if (preDialogData.isDuplicatedConversation) {
                $scope.chatLibrary.dialogIdList.splice(position);
            } else {
                $scope.chatLibrary.dialogIdList[position] = newLayoutId;
                $scope.chatLibrary.dialogDict[newLayoutId] = Object.assign({}, chatUtility.dialogInitValue);
            }
        } else {
            $scope.updateDialogList(newLayoutId, true);
        }
    }
    $scope.generateDialog = function (conversation, dialogType, preDialogData) {
        var oldLayoutId = preDialogData.layoutId;
        var newLayoutId = $scope.getLayoutId(conversation.id, dialogType);
        conversation['dialogType'] = dialogType;
        if (oldLayoutId !== newLayoutId) { 
            // update user data and friends library	
            $scope.getUserInfoForConversation(conversation);

            // fill the new conversation and update chatUserDict 
            conversation['layoutId'] = newLayoutId;
            conversation['isConversation'] = true;
            $scope.updateChatViewModel(conversation, true);

            // reset previous dialog and update dialogList for position and dialog status
            $scope.resetPreviousDialog(oldLayoutId, newLayoutId, preDialogData);
        } else {
            // update user data and friends library	
            $scope.getUserInfoForConversation(conversation);
            $scope.updateChatViewModel(conversation, true);
            $scope.chatLibrary.dialogDict[oldLayoutId].isUpdated = true;
            $scope.chatLibrary.dialogDict[oldLayoutId].updateStatus = chatUtility.dialogStatus.REFRESH;
        }
    }

    $scope.createNewGroupChat = function (layoutId, currentConversation) {
        if ($scope.newGroupChatLocked) {
            return;
        }
        $scope.newGroupChatLocked = true;

        var preDialogData = { layoutId: layoutId };
        var newTitle = currentConversation.name;
        if (currentConversation.addMoreFriends && !currentConversation.isGroupChat) {
            var participantUsers = currentConversation.participants;
            angular.forEach(participantUsers, function (user) {
                var userId = user.targetId;
                if (userId !== $scope.chatLibrary.userId) {
                    currentConversation.selectedUserIds.push(userId);
                    currentConversation.selectedUsersDict[userId] = angular.copy($scope.chatLibrary.friendsDict[userId]);
                    currentConversation.selectedUsersDict[userId].hiddenFromSelection = true;
                }
            });
            preDialogData.preserved = true;
            newTitle = "";
        }
        chatService.startGroupConversation(currentConversation.selectedUserIds, newTitle)
            .then(function (data) {
                if (data.resultType === chatUtility.resultType.SUCCESS) {
                    var conversation = data.conversation;
                    var layoutId = $scope.chatLibrary.allConversationLayoutIdsDict[conversation.id];
                    if (layoutId) { // duplicate group conversation
                        preDialogData.isDuplicatedConversation = true;
                        $scope.resetPreviousDialog(currentConversation.layoutId, layoutId, preDialogData);
                        if ($scope.chatLibrary.dialogIdList.indexOf(layoutId) < 0) {
                            $scope.launchDialog(layoutId, true);
                        }
                    } else {
                        conversation.isGroupChat = conversation.conversationType === chatUtility.conversationType.multiUserConversation;
                        messageService.formatTimestampInConversation(conversation);
                        $scope.generateDialog(conversation, chatUtility.dialogType.GROUPCHAT, preDialogData);
                    }
                }
                $scope.newGroupChatLocked = false;
            })
            .catch(function (ex) {
                $scope.newGroupChatLocked = false;
            });
    }

    $scope.sendInvite = function (layoutId) {
        $log.debug("------------- sendInvite ------------");
        var currentConversation = $scope.chatUserDict[layoutId];
        if ((currentConversation.dialogType === chatUtility.dialogType.CHAT ||
            currentConversation.dialogType === chatUtility.dialogType.GROUPCHAT) &&
            !currentConversation.addMoreFriends) {
            const userIds = currentConversation.userIds;
            var myPosition = userIds.indexOf($scope.chatLibrary.userId);
            if (myPosition > -1) {
                userIds.splice(myPosition, 1);
            }
            currentConversation.selectedUserIds = userIds;
        } else if ($scope.canAddFriendInExistedConversation(currentConversation)) {
            chatService.addToConversation(currentConversation.selectedUserIds, currentConversation.id)
                        .then(
                        function (data) {
                            if (data && data.resultType === chatUtility.resultType.SUCCESS && data.conversationId) {
                                currentConversation.addMoreFriends = false;
                                currentConversation['userIds'] = currentConversation['userIds'].concat(currentConversation['selectedUserIds']);
                                currentConversation['selectedUserIds'] = [];
                                currentConversation['selectedUsersDict'] = {};
                            }
                        });
        } else if ($scope.isNewGroupChat(currentConversation)) {
            $scope.createNewGroupChat(layoutId, currentConversation);
        }
    }
};

chatModule.controller("dialogsController", dialogsController);

export default dialogsController;